<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-visible-menu':state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @closeMenu="state.visibleMenu = false"
    />

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true;state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <div class="header-title">
            <h1>お問い合わせ</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-container" style="min-height:calc(100vh - 64px);">
            <div id="content">
              <div class="contact">
                <div class="contact-head">
                  <div class="breadcrumb">
                    <span class="breadcrumb-link current">お問い合わせ</span>
                    <span class="breadcrumb-link">お問い合わせ内容の確認</span>
                    <span class="breadcrumb-link">お問い合わせ受付の完了</span>
                  </div>
                </div>
                <form @submit.prevent class="contact-container">
                  <div class="contact-content">
                    <p class="txt mb20">以下に必要事項を入力してお問い合わせください。</p>
                    <p class="txt" :class="group1.isError ? 'mb20' : 'mb40'">コンテンツの内容に関するお問い合わせについて<br>
                      書籍名などコンテンツの該当箇所、ご質問内容をご明示ください。（書籍名と該当箇所、ご質問の内容をお知らせください。）<br>
                      なお、法令条文の解釈や法律相談、個別事例等にはお答えできません。また、お問い合わせ内容によって、お答えに時間をいただく場合がございます。
                    </p>
                    <p class="txt error-message mb40" v-if="group1.isError">入力内容に不備があるようです。下記メッセージ（赤文字）のご確認をお願いいたします。</p>

                    <h2 class="hdg03">お問い合わせフォーム</h2>
                    <ul class="contact-content-list">
                      <li class="contact-content-list-item">
                        <table class="contact-content-table">
                          <colgroup>
                            <col style="width:30%;">
                            <col sytle="width:70%;">
                          </colgroup>
                          <tbody>
                            <tr>
                              <th class="pt20">
                                お問い合わせ内容<span class="txt-red">[必須]</span>
                              </th>
                              <td>
                                <div class="formparts select"
                                  v-click-outside="() => { group1.isVisibleTypeList = false }"
                                  :class="{ 'is-visible-list': group1.isVisibleTypeList }"
                                >
                                  <div class="select-label" role="select"
                                    @click="group1.isVisibleTypeList = !group1.isVisibleTypeList"
                                    >{{ group1.message_type || '選択してください' }}<FontawesomeIcon :icon="group1.isVisibleTypeList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                                  <div class="select-option">
                                    <ul class="select-option-list">
                                      <li 
                                        v-for="item in group1.listTypeItem" :key="'type_' + item.value"
                                        class="ta-center" role="option">
                                        <label><input type="radio" :value="item.value" v-model="group1.currentTypeValue"
                                          @click="group1.onTypeListSelected(item.label)">{{ item.label }}</label>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <p class="error-message" v-if="group1.error_message_type">{{group1.error_message_type}}</p>

                                <div class="formparts textarea">
                                  <textarea v-model="group1.message" rows="5" placeholder="お問い合わせ内容をご入力ください。"></textarea>
                                  <p class="error-message" v-if="group1.error_message">{{group1.error_message}}</p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </li>
                    </ul>
                    
                    <div class="contact-submit">
                      <div class="button contact-submit-button">
                        <button class="btn" @click="group1.submitButtonClicked">次へ</button>
                      </div>
                    </div>
                    
                  </div>
                </form>
              </div>
            </div>
            
          </div>
        </div>
      </div>


    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import ClickOutside from 'vue-click-outside'

import store from '@/store'
import SPMenu from '@/components/sp/popup/SPMenu.vue'
import * as logicLoggedinInquiry from '@/logic/inquiry/LoggedinInquiry.js'

export default defineComponent({
  components: {
    SPMenu
  },
  directives: {
    ClickOutside
  },
  beforeRouteEnter (to, from, next) {
    if (from.name !== 'SPInquiryConfirm') {
      // 確認画面以外から遷移して来た場合はストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
    }
    next()
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicLoggedinInquiry.getGroupIndex()

    const state = reactive({
      visibleMenu: false
    })
   
    return {
      group1,
      state
    }
  }
})
</script>

<style lang="scss" scoped>
.contact-container {
  padding-bottom: 0;
}
.menu-btn-2 {
  border-radius: 8px 0 0 0;
}
</style>
